import Spinner, { SpinnerText } from '@anwb/poncho/components/spinner';
import { pxToRem } from '@anwb/poncho/design-tokens/style-utilities';
import { DefaultThemeProps } from '@anwb/poncho/design-tokens/theme';
import styled, { css } from 'styled-components';

const UserInformationContainerStyles = ({ $loading }: { $loading: boolean }) => css`
	${$loading === true &&
	css`
		user-select: none;
		pointer-events: none;

		& > * {
			transition: opacity 0.2s;
			opacity: 0.3;
		}
	`}
`;

export const UserInformationContainer = styled.div`
	${UserInformationContainerStyles}
`;

const MembershipCheckSpinnerStyles = ({ theme }: DefaultThemeProps) => css`
	opacity: 1;
	position: absolute;
	top: 70%;
	left: 35%;
	transform: translateX(-50%);

	@media (max-width: ${pxToRem(theme.viewportBreakpoint.sm)}) {
		left: 50%;
	}

	${SpinnerText} {
		white-space: nowrap;
	}
`;

export const MembershipCheckSpinner = styled(Spinner)`
	${MembershipCheckSpinnerStyles}
`;
